import React from 'react';
import { getAccessToken, getLob } from '../../services/authenticationService';
import { EnvironmentRegistry } from '../../services/registry/environmentRegistry';

function InsightsDashboard() {
  const lob = getLob();
  const env = EnvironmentRegistry.getEnvironment() || 'uat';
  const token = getAccessToken();
  const baseUrl = EnvironmentRegistry.getInsightsUrl(env);
  const iframeSrc = `${baseUrl}/lob/${lob}?env=${env}&token=${token}`;
  return (
    <div style={{ height: '100vh', width: '100%' }}>
      <iframe
        src={iframeSrc} // Use the dynamically constructed URL
        title="Insights Dashboard"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
    </div>
  );
}

export default InsightsDashboard;
